// extracted by mini-css-extract-plugin
module.exports = {"container":"Terms_container_3Y0pZ","backButton":"Terms_backButton_1PlkF"};